__turbopack_context__.v({
  "accountButton": "tablet-module-sass-module__ptBuaG__accountButton",
  "accountButtonActive": "tablet-module-sass-module__ptBuaG__accountButtonActive",
  "active": "tablet-module-sass-module__ptBuaG__active",
  "collapseBtn": "tablet-module-sass-module__ptBuaG__collapseBtn",
  "header": "tablet-module-sass-module__ptBuaG__header",
  "headerAccountPopover": "tablet-module-sass-module__ptBuaG__headerAccountPopover",
  "headerButtons": "tablet-module-sass-module__ptBuaG__headerButtons",
  "loginBtn": "tablet-module-sass-module__ptBuaG__loginBtn",
  "notificationsCount": "tablet-module-sass-module__ptBuaG__notificationsCount",
  "opened": "tablet-module-sass-module__ptBuaG__opened",
  "registerBtn": "tablet-module-sass-module__ptBuaG__registerBtn",
  "walletButton": "tablet-module-sass-module__ptBuaG__walletButton",
});
